// extracted by mini-css-extract-plugin
module.exports = {"desktop_tooltip":"Datepicker_desktop_tooltip__mj28F"};